import { render, staticRenderFns } from "./soilScreen.vue?vue&type=template&id=03d238cb&scoped=true&"
import script from "./soilScreen.vue?vue&type=script&lang=js&"
export * from "./soilScreen.vue?vue&type=script&lang=js&"
import style0 from "./soilScreen.vue?vue&type=style&index=0&id=03d238cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d238cb",
  null
  
)

export default component.exports